// extracted by mini-css-extract-plugin
module.exports = {"products":"section-with-products_products__1WXMa"};